import React, { FC } from 'react';
import useDashboardStats from 'wb-spotify/app/routes/superGrid/hooks/useDashboardStats';
import { LEVEL_ID_FILTER } from 'wb-spotify/app/routes/superGrid/actionRow/filters/utils';
import NameCellRenderer from 'wb-spotify/app/routes/superGrid/cellRenderers/name/name';
import KpiDropdown from 'wb-spotify/app/routes/superGrid/cellRenderers/name/kpiDropdown';
import NameDashboardCharts from 'wb-spotify/app/routes/superGrid/cellRenderers/name/charts/container';
import NameCellPerformers from 'wb-spotify/app/routes/superGrid/cellRenderers/name/performers';
import { ICellRendererParams } from 'ag-grid-community';
import { DashboardCellRendererFrame } from '@aleph/shared-components';

const SpotifyNameCellRenderer: FC<ICellRendererParams> = (params) => {
	const isDashboardView = params.data?.isDashboardView && !params.node.expanded;
	const focusedCell = params.api?.getFocusedCell();
	const isFocusedOnThisRow = focusedCell?.rowIndex === params.rowIndex;
	const selectedKPI = params.data?.clientKpi ?? null;

	const {
		loading, bestPerformers, worstPerformers,
	} = useDashboardStats({
		parentFilter: {
			[LEVEL_ID_FILTER[params.data?.level ?? '']]: [{ value: [params.data?.id] }],
		},
		focusedCell: isFocusedOnThisRow ? focusedCell : null,
		skip:        !isDashboardView,
		selectedKPI,
	});
	const hasKpi = params?.data?.clientKpi && params?.data?.clientBreakdown;

	if (!isDashboardView) {
		return (
			<NameCellRenderer
				{...params}
			/>
		);
	}

	return (
		<DashboardCellRendererFrame>
			<NameCellRenderer
				{...params}
			/>

			{
				hasKpi ? <NameDashboardCharts {...params} /> : <KpiDropdown
					{...params}
					clientId={params?.data?.clientId}
				/>
			}

			<NameCellPerformers
				loading={loading}
				selectedKPI={selectedKPI}
				performersType="bestPerformers"
				performers={bestPerformers}
			/>

			<NameCellPerformers
				loading={loading}
				selectedKPI={selectedKPI}
				performersType="worstPerformers"
				performers={worstPerformers}
			/>
		</DashboardCellRendererFrame>
	);
};

export default SpotifyNameCellRenderer;
